import React, { useEffect } from "react";
import { useGetCategories } from "../hooks/use-getCategories";

export const TestUseGetCategories = () => {
  const {
    subLineasPorCategoria,
    obtenerSubLineasDisponibles,
    setSubLineasPorCategoria,
  } = useGetCategories();

  const testearHook = async () => {
    console.log("🔄 INICIANDO TEST DEL HOOK useGetCategories");
    console.log("=".repeat(60));
    
    try {
      console.log("📞 Llamando a obtenerSubLineasDisponibles()...");
      
      // Llamar a la función del hook
      await obtenerSubLineasDisponibles();
      
      // Esperar un poco para que se actualice el estado
      setTimeout(() => {
        console.log("\n📊 DATOS OBTENIDOS DEL HOOK:");
        console.log("Estado actual de subLineasPorCategoria:");
        console.log(JSON.stringify(subLineasPorCategoria, null, 2));
        
        console.log("\n" + "=".repeat(60));
        console.log("📋 ANÁLISIS POR CATEGORÍA:");
        
        let totalSubLineas = 0;
        let categoriasConDatos = 0;
        let categoriasSinDatos = 0;

        Object.entries(subLineasPorCategoria).forEach(([categoria, subLineas]) => {
          const cantidadSubLineas = Array.isArray(subLineas) ? subLineas.length : 0;
          totalSubLineas += cantidadSubLineas;
          
          if (cantidadSubLineas > 0) {
            categoriasConDatos++;
            console.log(`✅ ${categoria}: ${cantidadSubLineas} sublíneas`);
            
            // Mostrar las primeras 3 sublíneas
            subLineas.slice(0, 3).forEach((sublinea, index) => {
              console.log(`   ${index + 1}. ${sublinea.descripcion_sublinea} (ID: ${sublinea.sublinea_id})`);
            });
            if (cantidadSubLineas > 3) {
              console.log(`   ... y ${cantidadSubLineas - 3} más`);
            }
          } else {
            categoriasSinDatos++;
            console.log(`❌ ${categoria}: Sin datos`);
          }
        });

        console.log("\n" + "=".repeat(60));
        console.log("📊 RESUMEN DEL HOOK:");
        console.log(`   - Total categorías: ${Object.keys(subLineasPorCategoria).length}`);
        console.log(`   - Categorías con datos: ${categoriasConDatos}`);
        console.log(`   - Categorías sin datos: ${categoriasSinDatos}`);
        console.log(`   - Total sublíneas: ${totalSubLineas}`);
        console.log("=".repeat(60));

      }, 2000); // Esperar 2 segundos para que se complete la petición

    } catch (error) {
      console.error("❌ Error en el test del hook:", error);
    }
  };

  useEffect(() => {
    testearHook();
  }, []);

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h2>🔧 Test del Hook useGetCategories</h2>
      <p>Revisa la consola del navegador para ver los resultados</p>
      <button 
        onClick={testearHook}
        style={{
          padding: "10px 20px",
          backgroundColor: "#28a745",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          marginTop: "10px"
        }}
      >
        🔄 Volver a probar hook
      </button>
    </div>
  );
}; 